// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2283":"15794ec9750d8b90","3638":"b7771204e33f8371","4326":"da5494abcf28d686","4758":"279e6809a2bbec03"}[chunkId] + ".css";
};